import { Layout, Flex, Button, Dropdown, theme, ExplorerWordmark } from "@murm/ant";
import { QuestionCircleOutlined, UserOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { PENDO_ID, pendoId } from "../../lib/pendoIds";
import styles from "./ExplorerAppHeader.module.css";

const { Header } = Layout;

const HELP_CENTER_PATH = "/help-center";

/**
 * Explorer chrome: serif wordmark (design lib) + Help + account menu.
 * Fixed masthead: 56px, white bar (matches platform header chrome).
 */
export function ExplorerAppHeader() {
  const { token } = theme.useToken();
  const { user } = useAuth();
  const navigate = useNavigate();
  const displayName = user?.name || user?.email || "Account";

  return (
    <Header role="banner" className={styles.header}>
      <nav aria-label="Main" className={styles.nav}>
        <Flex justify="space-between" align="center" className={styles.bar}>
          <Link {...pendoId(PENDO_ID.NAV_LOGO)} to="/" aria-label="Explorer home" className={styles.logo}>
            <ExplorerWordmark size="header" />
          </Link>
          <Flex align="center" gap={token.marginSM}>
            <Button
              {...pendoId(PENDO_ID.NAV_HELP)}
              type="text"
              icon={<QuestionCircleOutlined />}
              aria-label="Help"
              className={styles.help}
              href={HELP_CENTER_PATH}
              target="_blank"
              rel="noopener noreferrer"
            />
            <Dropdown
              menu={{
                items: [
                  {
                    key: "logout",
                    label: "Log out",
                    ...pendoId(PENDO_ID.NAV_LOGOUT),
                    onClick: () => navigate("/logout"),
                  },
                ],
              }}
              trigger={["click"]}
            >
              <Button
                {...pendoId(PENDO_ID.NAV_ACCOUNT_MENU)}
                type="text"
                className={styles.account}
              >
                <UserOutlined aria-hidden />
                <span>{displayName}</span>
              </Button>
            </Dropdown>
          </Flex>
        </Flex>
      </nav>
    </Header>
  );
}
